import React, { forwardRef } from 'react'
import ObrysIkony from './ObrysIkony'

/**
 * Asystent doboru zestawu: dom z panelami na dachu („dobierz cały zestaw do swojego domu”).
 *
 * Zamiast gwiazdek (SparklesIcon), które właściciel odrzucił 2026-10-08 jako ikonę, którą każdy
 * dobiera do „AI”. Dom w ujęciu z boku, bo dopiero wtedy widać połać dachu: przy domku na wprost
 * (jak HomeIcon) panel na skosie wyglądał na komin, a siatka na całym dachu na straganik.
 * Siatka 2x2 zamiast gęstszej, żeby przy 16 px nie zlała się w jedną plamę.
 */
const IkonaAsystenta = forwardRef((props, ref) => (
  <ObrysIkony ref={ref} {...props}>
    {/* Szczyt od frontu i połać dachu z panelami. */}
    <path d='M2.25 11.25 7.5 4.5l5.25 6.75' />
    <path d='M7.5 4.5h9.75l5.25 6.75h-9.75' />
    <path d='M10.125 7.875h9.75M12.375 4.5l5.25 6.75' />
    {/* Ściany: front, bok i podział między nimi. */}
    <path d='M3.75 9.5v10.75H21v-9M12.75 11.25v9' />
    {/* Drzwi na środku frontu. */}
    <path d='M7.125 20.25v-3a1.125 1.125 0 0 1 2.25 0v3' />
  </ObrysIkony>
))

export default IkonaAsystenta
